<template>
  <div v-if="pagination.total_pages > 1" class="pagination-wrapper">
    <ul class="pagination">

      <!-- Previous -->
      <li :class="{ disabled: !pagination.has_prev }">
        <button @click="goToPage(pagination.page - 1)" :disabled=" loading ||!pagination.has_prev">
          Prev
        </button>
      </li>

      <!-- Page Numbers -->
      <li v-for="page in visiblePages" :key="page">
        <button
          @click="goToPage(page)"
          :class="{ active: pagination.page === page }"
          :disabled="loading"
        >
          {{ page }}
        </button>
      </li>

      <!-- Next -->
      <li :class="{ disabled: !pagination.has_next }">
        <button @click="goToPage(pagination.page + 1)" :disabled=" loading ||!pagination.has_next">
          Next
        </button>
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true
    },
    maxVisible: {
      type: Number,
      default: 5
    },
    loading: {
    type: Boolean,
    default: false
  }
  },

  computed: {
    visiblePages() {
      const total = this.pagination.total_pages;
      const current = this.pagination.page;
      const max = this.maxVisible;

      const start = Math.max(1, current - Math.floor(max / 2));
      const end = Math.min(total, start + max - 1);
      const adjustedStart = Math.max(1, end - max + 1);

      return Array.from(
        { length: end - adjustedStart + 1 },
        (_, i) => adjustedStart + i
      );
    }
  },

  methods: {
    goToPage(page) {
    if (this.loading) return;

    if (page === this.pagination.page) return;

    if (page < 1 || page > this.pagination.total_pages) return;

    this.$emit("page-changed", page);
  }
  }
};
</script>

<style scoped>
.pagination {
  display: flex;
  gap: 6px;
  list-style: none;
  justify-self: center;
}

button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
}

button.active {
  background: #007bff;
  color: white;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>